import React from "react";
import Button from "../button/Button";
import DeleteButton from "../button/DeleteButton";
import SimplePagination from "../Pagination/SimplePagination";

const QuestionnaireTable = ({
  questionnaires,
  onEdit,
  onDelete,
  isLoading = false,
  currentPage = 1,
  totalPages = 1,
  onPageChange,
  limit = 10,
  onLimitChange,
  totalItems = 0,
}) => {
  const getQuestionTypeLabel = (type) => {
    switch (type) {
      case "text":
        return "Text Input";
      case "single_choice":
        return "Single Choice";
      case "multiple_choice":
        return "Multiple Choice";
      default:
        return type;
    }
  };

  const getRequiredBadge = (isRequired) => {
    return isRequired ? (
      <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800">
        Required
      </span>
    ) : (
      <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800">
        Optional
      </span>
    );
  };

  const getOptionsPreview = (options, type) => {
    if (type === "text" || !options || options.length === 0) {
      return "N/A";
    }

    if (options.length <= 3) {
      return options.join(", ");
    }

    return `${options.slice(0, 3).join(", ")} +${options.length - 3} more`;
  };

  if (isLoading) {
    return (
      <div className="flex justify-center items-center py-8">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (!questionnaires || questionnaires.length === 0) {
    return (
      <div className="text-center py-8">
        <p className="text-gray-500 text-lg">
          No questionnaire templates found
        </p>
        <p className="text-gray-400 text-sm mt-2">
          Create your first template to get started
        </p>
      </div>
    );
  }

  return (
    <div className="overflow-hidden">
      {/* Table */}
      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Question
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Type
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Required
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Options
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Order
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Created
              </th>
              <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {questionnaires.map((questionnaire) => (
              <tr key={questionnaire._id} className="hover:bg-gray-50">
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="max-w-xs">
                    <p className="text-sm font-medium text-gray-900 truncate">
                      {questionnaire.question}
                    </p>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <span className="text-sm text-gray-900">
                    {getQuestionTypeLabel(questionnaire.questionType)}
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {getRequiredBadge(questionnaire.isRequired)}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="max-w-xs">
                    <p className="text-sm text-gray-900 truncate">
                      {getOptionsPreview(
                        questionnaire.options,
                        questionnaire.questionType
                      )}
                    </p>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <span className="text-sm text-gray-900">
                    {questionnaire.order}
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <span className="text-sm text-gray-900">
                    {new Date(questionnaire.createdAt).toLocaleDateString()}
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                  <div className="flex justify-end space-x-2">
                    <Button
                      text="Edit"
                      onClick={() => onEdit(questionnaire)}
                      customClass="bg-blue-600 hover:bg-blue-700"
                    />
                    <DeleteButton
                      text="Delete"
                      onClick={() => onDelete(questionnaire._id)}
                    />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <SimplePagination
        totalPages={totalPages}
        currentPage={currentPage}
        onPageChange={onPageChange}
        limit={limit}
        onLimitChange={onLimitChange}
        totalItems={totalItems}
      />
    </div>
  );
};

export default QuestionnaireTable;
